import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

import { contact } from 'contact/model/contact.fragments';
import { ApiPageableOutput } from 'infrastructure/common/model/api-pageable.output';
import { ApiQuery } from 'infrastructure/common/model/api.query';
import { SortDirection } from 'infrastructure/common/model/api.sort-direction';
import { jobOffer } from 'job/model/job-offer.fragments';
import { tasksParticipant } from 'task/model/task.fragments';
import { TaskOutput } from 'task/model/task.output';
import { TaskSortProperty } from 'task/model/task.sort-property';
import { TaskStatus } from 'task/model/task.status';

export interface SearchUserCoachMeetingsParams {
	readonly sortProperty?: TaskSortProperty;
	readonly sortDirection?: SortDirection;
	readonly dueStartTimestamp?: number;
	readonly description?: string;
	readonly dueEndTimestamp?: number;
	readonly statuses?: TaskStatus[];
	readonly chunkSize: number;
	readonly offset: number;
	readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class SearchUserCoachMeetingsApiQuery extends ApiQuery<
	ApiPageableOutput<TaskOutput>,
	SearchUserCoachMeetingsParams
> {
	client = 'iam';
	document = gql`
		query SearchUserCoachMeetings(
			$chunkSize: Int
			$description: String
			$dueEndTimestamp: Long
			$dueStartTimestamp: Long
			$offset: Int
			$sortDirection: Direction
			$sortProperty: TaskSort
			$statuses: [TaskStatus]
			$userId: UUID!
		) {
			searchUserCoachMeetings(
				chunkSize: $chunkSize
				description: $description
				dueEndTimestamp: $dueEndTimestamp
				dueStartTimestamp: $dueStartTimestamp
				offset: $offset
				sortDirection: $sortDirection
				sortProperty: $sortProperty
				statuses: $statuses
				userId: $userId
			) {
				elements {
					id
					done
					type
					owner {
						id
					}
					contact {
						...Contact
					}
					jobOffer {
						...JobOffer
					}
					modulesId
					todoTitle
					dueTimestamp
					updateTimestamp
					participants {
						...TasksParticipant
					}
					todoDescription
					externalEventTitle
					externalEventId
				}
				totalElements
			}
		}
		${tasksParticipant}
		${jobOffer}
		${contact}
	`;
	method = 'searchUserCoachMeetings';
}
